<p-card class ="pan-card"
  [styleClass]="'card-item'"
  [style]="{'height': payload.height}" [hidden]="!isdataRecieved">
  <p-header *ngIf="payload.showAll">
      <ispm-pan-cancer-card-header
        class="card-title"
        [header]="payload.name"
        [formHolder]="payload.widgetPayload"
        (countEmitter)="onCountEmit($event.showAllDataCount)"
      >
      </ispm-pan-cancer-card-header>
      <div>
          <span  *ngFor="let action of actionItems">
               <span *ngIf="action.toolTipText !== undefined">
                    <gen-button  *ngIf="action.type === 'edit'? permitPanCancerWrite : true" [type]="action.btnType" class="{{action.cssClass}}"
                                 (click)="performAction(action)"
                                 [iconClass]="action.iconName" [text]="action.name | translate"
                                 [hidden]="action.hideIcon"
                                 genTooltip
                                 style="color:white" tooltipPosition="BOTTOM" tooltipShow="true" tooltipText="{{action.toolTipText}}"
                    ></gen-button>
               </span>
              <span *ngIf="action.toolTipText === undefined">
                  <gen-button  *ngIf="action.type === 'edit'? permitPanCancerWrite : true" [type]="action.btnType" class="{{action.cssClass}}" (click)="performAction(action)"
                               [iconClass]="action.iconName" [text]="action.name | translate"

                  >  </gen-button>
              </span>

          </span>
          <!--?<gen-button *ngIf="!actionItems"
                  class="modal-action Auto_Popup_Action_Button"
                  [type]="'secondary'"
                  (click)="showAllModal()"
                  [text]="'Show all'| translate"
                  [iconClass]="''">
          </gen-button>-->
          <!--<div class="info-highlighter"  *ngIf="showAllDataCountValue > 0">
              <img src="{{showAllDataCountIconPath}}">
          </div>-->
      </div>
  </p-header>
  <div  *ngFor="let form of viewForms; let i = index">
    <gen-dynamic-form
      *ngIf="form.formId"
      class="info-dynamic-form"
      [formName]="form.formId"
      [formVertical]="form.formVertical === false ? false: true"
      [updateOnBlur]="false"
      [editMode]="true"
      [disabled]="form.disabled != false"
      [requiredMessage]="''"
      (dataRecieved)="dataRecievedEvent($event, i)"
      (cardInfoEmitter)="dataReceivedForm($event, i)"
      [itemCount]="form.showCount">
    </gen-dynamic-form>
      </div>
</p-card>

<gen-dynamic-modal-loader class="pan-cancer-event-modal" [observableName]="ModalLoaderTunnelName"></gen-dynamic-modal-loader>
<gen-dynamic-modal-loader class="pan-cancer-event-modal" [observableName]="ModalLoaderTunnelNameEdit"></gen-dynamic-modal-loader>
<div *ngIf="!isdataRecieved" class ="skeleton loading skeletoncard"></div>
